export enum CampaignErrorCodes {
  NotSupportGeneralSearchFilters = 'not_support_general_search_filters',
  UpdateSearchUrl = 'error_update_search_url',
  UpdateCsv = 'error_update_csv',
  UpdateRetention = 'error_update_retention',
  MessageRequest = 'error_message_request',
  BigUrlPotential = 'error_big_url_potential',
  ZeroUrlPotential = 'error_zero_url_potential',
  OutdatedSearchUrl = 'error_outdated_search_url',
  RequestTimedOut = 'error_request_timed_out',
  TooManyRequests = 'error_too_many_requests',
  NoGroupFilter = 'error_no_group_filter',
  WrongSearchUrl = 'error_wrong_search_url',
  CsvFeature = 'error_csv_feature',
  UpdateMultipleSearchUrl = 'error_update_multiple_search_url',
  EmailRestrictedWarning = 'error_email_restricted_warning',
  InmailLimitReached = 'error_inmail_limit_reached',
  InmailCreditsExhausted = 'error_inmail_credits_exhausted',
  SecondFollowupUndefined = 'error_second_followup_undefined',
  ThirdFollowupUndefined = 'error_third_followup_undefined',
  ProfileViewRestricted = 'error_profile_view_restricted',
  AllMessagesSent = 'error_all_messages_sent',
  EmailInvitesAllMessagesSent = 'error_email_invites_all_messages_sent',
  WeeklyLimitWarning = 'error_weekly_limit_warning',
  DailyLimitWarning = 'error_daily_limit_warning',
  Default = 'error_default',
  ProfileViewLimitReached = 'error_profile_view_limit_reached',
  SnSearchView = 'error_sn_search_view',
  WarningSnSearchNoConnectionFilter = 'warning_sn_search_no_connection_filter',
  WarningUserDoesNotHaveActiveSN = 'warning_user_does_not_have_active_SN',
  InviteMessageLimit = 'error_invite_message_limit',
  CampaignSourcesLimited = 'error_campaign_sources_limited',
  InviteLiBasicPersonalizedInvite = 'error_invite_li_basic_personalized_invite',
  CampaignUserNotFound = 'error_campaign_user_not_found',
  SnSubscriptionNotFound = 'error_sn_subscription_not_found',
}
